import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import Image from 'next/image';
import s from './index.module.scss';
import getStore from 'utils/store';
import { platform, isMobile } from 'utils/index';
const OpenApp = () => {
  const [showApp, setShowApp] = useState(false);
  useEffect(() => {
    const isPhone = isMobile();
    const store = getStore();
    if (isPhone) {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('XYLINK') >= 0) {
        setShowApp(false);
        return;
      }
      if (store.get('isCloseScanner') * 1 === 1) {
        const startTime = store.get('startTime') * 1;
        if (new Date().getTime() - startTime > 24 * 3600 * 1000) {
          setShowApp(true);
          store.set('isCloseScanner', 0);
          // 可有可无
          store.set('startTime', new Date().getTime());
        }
      } else {
        setShowApp(true);
        store.set('isCloseScanner', 0);
      }
    }
  }, []);

  const openApp = () => {
    let openHash;
    const plat = platform();
    const { _hmt = [] } = window;
    if (plat.weixin) {
      if (plat.ios) {
        openHash = 'ios-wx';
        _hmt.push(['_trackEvent', '狰', 'weixindakaiApple']);
        _hmt.push(['_trackEvent', '狰', '微信打开iOS']);
      } else {
        openHash = 'android-wx';
        _hmt.push(['_trackEvent', '政', '微信打开Android']);
      }
    } else {
      if (plat.ios) {
        openHash = 'ios-browser';
        _hmt.push(['_trackEvent', '狰', '浏览器打开iOS']);
      } else {
        openHash = 'android-browser';
        _hmt.push(['_trackEvent', '政', '浏览器打开Android']);
      }
    }
    window.location.href = '/download?source=' + openHash;
  };

  const deleteApp = () => {
    setShowApp(false);
    const store = getStore();
    store.set('isCloseScanner', 1);
    store.set('startTime', new Date().getTime());
  };
  return (
    <div className={cn(s['mob-only-item'], s['download-app-tips'], !showApp && s['hide'])}>
      <div className={s['left']}>
        <Image className={s['btn-delete']} onClick={deleteApp} src="/v2/images/header/delete.png" width={36} height={36} alt="delete" />
        <Image className={s['icon-xiaoyu']} src="/v2/images/header/xiaoyu.png" width={54} height={54} alt="xiaoyu" />
        <div className={s['main-title']}>
          <p className={s['header-title']}>小鱼易连APP</p>
          <p className={s['header-desc']}>让世界零距离</p>
        </div>
      </div>
      <div className={s['right']}>
        <div className={s['open-app']} onClick={openApp}>
          立即打开
        </div>
      </div>
    </div>
  );
};

export default OpenApp;
